<app-skeleton-template *ngIf="!loadInfo" [template]="skeletonTemplate"></app-skeleton-template>

<ng-container *ngIf="loadInfo">
  <p class="text-info mb-sm">Alimentación</p>
  <form [formGroup]="nutritionalForm" novalidate nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24" [nzXl]="24">
    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col
        [nzXs]="24"
        [nzMd]="24"
        [nzLg]="!this.nutritionalForm.get('digestionProblems').value || this.nutritionalForm.get('digestionProblems').value === 'no' ?
        12 :
        8" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Acostumbra alguna alimentación especial?</div>
        <nz-select formControlName="feedingPreference" nzPlaceHolder="Seleccione la opción"
          [nzDropdownRender]="renderTemplateMoreOptionRegimen">
          <nz-option *ngFor="let regimen of nutritionalRegimen" [nzValue]="regimen.value" [nzLabel]="regimen.label"></nz-option>
        </nz-select>

        <ng-template #renderTemplateMoreOptionRegimen>
          <nz-divider style="margin: 5px 0;"></nz-divider>
          <div class="container-more-option">
            <input type="text" nz-input #inputElement placeholder="Otra opción" />
            <a class="add-item" (click)="onAddOtherNutritionalRegimen(inputElement)">
              <button nz-button nzType="default" class="btn-default"><i nz-icon nzType="plus" nzTheme="outline"></i></button>
            </a>
          </div>
        </ng-template>
        <!--<app-message-field [field]="nutritionalForm.get('nutritionalRegimen')"></app-message-field>-->
      </div>
      <div nz-col [nzXs]="24"
        [nzMd]="24"
        [nzLg]="!this.nutritionalForm.get('digestionProblems').value || this.nutritionalForm.get('digestionProblems').value === 'no' ?
        12 :
        8"
        class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Padece problemas de digestión?</div>
        <nz-select formControlName="digestionProblems" nzPlaceHolder="Seleccione la opción">
          <nz-option [nzValue]="'no'" nzLabel="No"></nz-option>
          <nz-option [nzValue]="'inflamación intestinal'" nzLabel="Inflamación intestinal"></nz-option>
          <nz-option [nzValue]="'dolor en estómago'" nzLabel="Dolor en estómago"></nz-option>
          <nz-option [nzValue]="'vómito'" nzLabel="Vómito"></nz-option>
          <nz-option [nzValue]="'diarrea'" nzLabel="Diarrea"></nz-option>
          <nz-option [nzValue]="'estreñimiento'" nzLabel="Estreñimiento"></nz-option>
          <nz-option [nzValue]="'gases'" nzLabel="Gases"></nz-option>
          <nz-option [nzValue]="'reflujo'" nzLabel="Reflujo"></nz-option>
        </nz-select>
        <!--<app-message-field [field]="nutritionalForm.get('constipationProblems')"></app-message-field>-->
      </div>
      <div nz-col [nzXs]="24"
        [nzMd]="24"
        [nzLg]="!this.nutritionalForm.get('digestionProblems').value || this.nutritionalForm.get('digestionProblems').value === 'no' ?
        12 :
        8" class="mb-sm d-flex flex-column justify-content-between" *ngIf="nutritionalForm.get('digestionProblems').value &&
        nutritionalForm.get('digestionProblems').value !== 'no'"
        @fadeInAnimation>
        <div class="input-label-form">Nota sobre problemas de digestión</div>
        <input nz-input type="text" formControlName="digestionProblemsNotes" placeholder="Escribe una nota ...">
        <!--<app-message-field [field]="nutritionalForm.get('takeLaxatives')"></app-message-field>-->
      </div>
    </div>

    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col [nzXs]="24" class="d-flex flex-column justify-content-between">
        <p class="input-label-form">Añade qué alimentos le gustaría consumir al paciente en su plan de alimentación.</p>

        <div class="tw-flex tw-items-center tw-flex-wrap tw-gap-3">
          <div class="more-options ingredient-tag" *ngFor="let ingredient of excludedLikeIngredients; index as i">
            <p class="text-info tw-text-gray-700">{{ingredient.ingredientName}}</p>
            <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="icon-action danger" (click)="onRemoveLikeIngredient(i)" *ngIf="!(isPatient$ | async)">
              <i nz-icon nzType="delete" nzTheme="outline"></i>
            </div>
          </div>
          <p *ngIf="excludedLikeIngredients.length === 0 && (isPatient$ | async)" class="text-info">No se han registrado alimentos</p>
        </div>
        <app-ingredient-selector
          *ngIf="!(isPatient$ | async)"
          [disabled]="(this.isPatient$ | async)"
          [hasCategoryFilter]="true"
          [hasIngredientName]="true"
          [showForm]="true"
          [excludedIngredients]="this.excludedLikeIngredientIds"
          (selected)="onSelectedLikeIngredient($event)"
          class="tw-mt-3"
        ></app-ingredient-selector>
      </div>

      <div nz-col [nzXs]="24" class="d-flex flex-column justify-content-between">
        <p class="input-label-form">Añade qué alimentos no le gustaría consumir al paciente en su plan de alimentación.</p>

        <div class="tw-flex tw-items-center tw-flex-wrap tw-gap-3">
          <div class="more-options ingredient-tag" *ngFor="let ingredient of excludedDislikeIngredients; index as i">
            <p class="text-info tw-text-gray-700">{{ingredient.ingredientName}}</p>
            <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="icon-action danger" (click)="onRemoveDislikeIngredient(i)" *ngIf="!(isPatient$ | async)">
              <i nz-icon nzType="delete" nzTheme="outline"></i>
            </div>
          </div>
          <p *ngIf="excludedDislikeIngredients.length === 0 && (isPatient$ | async)" class="text-info">No se han registrado alimentos</p>
        </div>
        <app-ingredient-selector
          *ngIf="!(isPatient$ | async)"
          [disabled]="(this.isPatient$ | async)"
          [hasCategoryFilter]="true"
          [hasIngredientName]="true"
          [showForm]="true"
          [excludedIngredients]="this.excludedDislikeIngredientIds"
          (selected)="onSelectedDislikeIngredient($event)"
          class="tw-mt-3"
        ></app-ingredient-selector>
      </div>

      <div nz-col [nzXs]="24" class="mb-sm d-flex flex-column justify-content-between">
        <p class="input-label-form">Añade qué alimentos le producen alergia al paciente.</p>
        <div class="tw-flex tw-items-center tw-flex-wrap tw-gap-3 tw-mb-3">
          <div class="more-options ingredient-tag tw-items-start" *ngFor="let ingredient of excludedAllergyIngredients; index as i">
            <div class="text-info">
              <p class="tw-text-gray-700">{{ingredient.ingredientName}}</p>
              <p class="tw-text-gray-400">{{ingredient.allergyDate | date:this.platformConfig.FORMAT.DATE.DDMMYYYY }}</p>
            </div>
            <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="icon-action danger"
                 (click)="this.onRemoveAllergyIngredient(i)" *ngIf="!(isPatient$ | async)">
              <i nz-icon nzType="delete" nzTheme="outline"></i>
            </div>
          </div>
          <p *ngIf="excludedAllergyIngredients.length === 0 && (isPatient$ | async)" class="text-info">No se han registrado alergias</p>
        </div>
        <button
          *ngIf="!(isPatient$ | async)"
          nz-popover="" nzPopoverTitle="" [nzPopoverContent]="'Agregar nueva alergia'" nzPopoverMouseEnterDelay="0.3"
          nzPopoverPlacement="topLeft"
          (click)="onOpenModalAddAllergy()"
          nz-button
          class="add-category-btn tw-w-max"
          @fadeInAnimation>
          <i nz-icon nzType="plus" nzTheme="outline" style="font-size: 11px;"></i>
        </button>
      </div>
    </div>

    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col
        [nzXs]="24"
        [nzMd]="24"
        [nzLg]="this.nutritionalForm.get('cookingOilOrLard').value && this.nutritionalForm.get('cookingOilOrLard').value === typesOfFat.OIL
        ? 8 :
        12" class="mb-sm
        d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Consume carnes blancas o rojas fritas,empanizadas o capeadas?</div>
        <nz-select formControlName="eatMeat" nzPlaceHolder="Seleccione la opción">
          <nz-option [nzValue]="timesEnum.NO" nzLabel="No"></nz-option>
          <nz-option [nzValue]="timesEnum.DAILY" nzLabel="Diariamente"></nz-option>
          <nz-option [nzValue]="timesEnum.TWO_TIMES_A_WEEK" nzLabel="2 veces por semana"></nz-option>
          <nz-option [nzValue]="timesEnum.THREE_OR_MORE_TIMES_A_WEEK" nzLabel="3 o más veces por semana"></nz-option>
        </nz-select>
        <!--<app-message-field [field]="nutritionalForm.get('eatBetweenMeals')"></app-message-field>-->
      </div>
      <div nz-col
        [nzXs]="24"
        [nzMd]="24"
        [nzLg]="this.nutritionalForm.get('cookingOilOrLard').value && this.nutritionalForm.get('cookingOilOrLard').value === typesOfFat.OIL
        ? 8 :
        12" class="mb-sm
        d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Cocina con aceite o manteca?</div>
        <nz-select formControlName="cookingOilOrLard" nzPlaceHolder="Seleccione la opción" (change)="onUpdateValidators('cookingOilOrLard')">
          <nz-option [nzValue]="typesOfFat.OIL" nzLabel="Aceite"></nz-option>
          <nz-option [nzValue]="typesOfFat.LARD" nzLabel="Manteca"></nz-option>
        </nz-select>
        <!--<app-message-field [field]="nutritionalForm.get('eatMeat')"></app-message-field>-->
      </div>
      <div nz-col
        [nzXs]="24"
        [nzMd]="24"
        [nzLg]="this.nutritionalForm.get('cookingOilOrLard').value && this.nutritionalForm.get('cookingOilOrLard').value === typesOfFat.OIL
        ? 8 :
        12" class="mb-sm
        d-flex flex-column justify-content-between" @fadeInAnimation *ngIf="nutritionalForm.get('cookingOilOrLard').value &&
        nutritionalForm.get('cookingOilOrLard').value === typesOfFat.OIL">
        <div class="input-label-form">¿Con qué aceite cocina?</div>
        <div>
          <input nz-input type="text" formControlName="oilName" required>
          <app-message-field [field]="nutritionalForm.get('oilName')"></app-message-field>
        </div>
      </div>
    </div>

    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col [nzXs]="24" [nzLg]="12" class="mb-sm
        d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Qué tipo de alimentos consume entre comidas?</div>
        <nz-input-group nzCompact class="d-flex">
          <nz-select formControlName="foodTypesBetweenMeals" nzPlaceHolder="Seleccione la opción" [nzOptionHeightPx]="120"
            (change)="onUpdateValidators('foodTypesBetweenMeals')">
            <nz-option nzCustomContent nzLabel="No consumo nada entre comidas" [nzValue]="typeBetweenMealsEnum.NO">
              <p class="text-info">No consumo nada entre comidas</p>
            </nz-option>
            <nz-divider style="margin: 15px 0;"></nz-divider>
            <nz-option nzCustomContent nzLabel="Dulces" [nzValue]="typeBetweenMealsEnum.SWEET">
              <p class="text-info">Dulces:</p>
              <ul class="ingredient-list ml-xs">
                <li>Galletas</li>
                <li>Pan dulce</li>
                <li>Dulces</li>
                <li>Pastelitos</li>
                <li>Postres</li>
              </ul>
            </nz-option>
            <nz-divider style="margin: 15px 0;"></nz-divider>
            <nz-option nzCustomContent nzLabel="Salados" [nzValue]="typeBetweenMealsEnum.SALTY">
              <p class="text-info">Salados:</p>
              <ul class="ingredient-list ml-xs">
                <li>Cacahuates</li>
                <li>Papitas</li>
                <li>Churritos</li>
                <li>Chicharrones</li>
                <li>Botana salada</li>
              </ul>
            </nz-option>
          </nz-select>
          <!--<app-message-field [field]="nutritionalForm.get('eatBetweenMeals')"></app-message-field>-->
          <div>
            <nz-select required formControlName="FoodTypesBetweenMealsConsumptionTimes" nzPlaceHolder="Seleccione la opción"
              *ngIf="nutritionalForm.get('foodTypesBetweenMeals').value &&
              nutritionalForm.get('foodTypesBetweenMeals').value !== typeBetweenMealsEnum.NO">
              <nz-option [nzValue]="timesEnum.DAILY" nzLabel="Diariamente"></nz-option>
              <nz-option [nzValue]="timesEnum.TWO_TIMES_A_WEEK" nzLabel="2 veces por semana"></nz-option>
              <nz-option [nzValue]="timesEnum.THREE_OR_MORE_TIMES_A_WEEK" nzLabel="3 o más veces por semana"></nz-option>
            </nz-select>
            <app-message-field [field]="nutritionalForm.get('FoodTypesBetweenMealsConsumptionTimes')"></app-message-field>
          </div>
        </nz-input-group>
      </div>
      <div nz-col [nzXs]="24" [nzLg]="12" class="mb-sm
        d-flex flex-column justify-content-between">
        <div class="input-label-form">Menciona que alimentos acostumbra consumir en fin de semana</div>
        <input nz-input type="text" formControlName="weekendFood" placeholder="Escribe ...">
        <!--<app-message-field [field]="nutritionalForm.get('eatMeat')"></app-message-field>-->
      </div>
    </div>

    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col [nzXs]="24" [nzLg]="12" class="mb-sm
        d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Cuántas comidas principales al día se preparan en casa?</div>
        <nz-input-number formControlName="howManyMainMealsPerDay" [nzMin]="0" [nzMax]="3" [nzStep]="1"></nz-input-number>
      </div>
      <div nz-col [nzXs]="24" [nzLg]="12" class="mb-sm
        d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Cuántas comidas principales son adquiridas fuera de casa?</div>
        <nz-input-number formControlName="howManyMainMealArePurchased" [nzMin]="0" [nzMax]="3" [nzStep]="1"></nz-input-number>
      </div>
    </div>

    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col [nzXs]="24" [nzLg]="12" class="mb-sm
        d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Consume frutas?</div>
        <nz-select formControlName="eatFruits" nzPlaceHolder="Seleccione la opción">
          <nz-option [nzValue]="timesEnum.NO" nzLabel="No"></nz-option>
          <nz-option [nzValue]="timesEnum.DAILY" nzLabel="Diariamente"></nz-option>
          <nz-option [nzValue]="timesEnum.TWO_TIMES_A_WEEK" nzLabel="2 veces por semana"></nz-option>
          <nz-option [nzValue]="timesEnum.THREE_OR_MORE_TIMES_A_WEEK" nzLabel="3 o más veces por semana"></nz-option>
        </nz-select>
      </div>
      <div nz-col [nzXs]="24" [nzLg]="12" class="mb-sm
        d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Cuántas frutas suele consumir al día?</div>
        <nz-input-number formControlName="howManyFruits" [nzMin]="0" [nzStep]="1"></nz-input-number>
      </div>
    </div>

    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col [nzXs]="24" [nzLg]="12" class="mb-sm
        d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Consume verduras?</div>
        <nz-select formControlName="eatVegetables" nzPlaceHolder="Seleccione la opción">
          <nz-option [nzValue]="timesEnum.NO" nzLabel="No"></nz-option>
          <nz-option [nzValue]="timesEnum.DAILY" nzLabel="Diariamente"></nz-option>
          <nz-option [nzValue]="timesEnum.TWO_TIMES_A_WEEK" nzLabel="2 veces por semana"></nz-option>
          <nz-option [nzValue]="timesEnum.THREE_OR_MORE_TIMES_A_WEEK" nzLabel="3 o más veces por semana"></nz-option>
        </nz-select>
      </div>
      <div nz-col [nzXs]="24" [nzLg]="12" class="mb-sm
        d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Cuántas verduras suele consumir al día?</div>
        <nz-input-number formControlName="howManyVegetables" [nzMin]="0" [nzStep]="1"></nz-input-number>
      </div>
    </div>

    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col [nzXs]="24" [nzLg]="12" class="mb-sm
        d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Toma bebidas azucaradas?</div>
        <nz-select formControlName="drinkSugaryDrinks" nzPlaceHolder="Seleccione la opción">
          <nz-option [nzValue]="timesEnum.NO" nzLabel="No"></nz-option>
          <nz-option [nzValue]="timesEnum.DAILY" nzLabel="Diariamente"></nz-option>
          <nz-option [nzValue]="timesEnum.TWO_TIMES_A_WEEK" nzLabel="2 veces por semana"></nz-option>
          <nz-option [nzValue]="timesEnum.THREE_OR_MORE_TIMES_A_WEEK" nzLabel="3 o más veces por semana"></nz-option>
        </nz-select>
      </div>
      <div nz-col [nzXs]="24" [nzLg]="12" class="mb-sm
        d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Cuántas bebidas azucaradas suele tomar al día?</div>
        <nz-input-number formControlName="howManySugaryDrinks" [nzMin]="0" [nzStep]="1"></nz-input-number>
      </div>
    </div>

    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col [nzXs]="24" [nzLg]="12" class="mb-sm
        d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Con qué frecuencia consume comida rápida?</div>
        <nz-select formControlName="eatFastFood" nzPlaceHolder="Seleccione la opción">
          <nz-option [nzValue]="timesEnum.NO" nzLabel="No"></nz-option>
          <nz-option [nzValue]="timesEnum.DAILY" nzLabel="Diariamente"></nz-option>
          <nz-option [nzValue]="timesEnum.TWO_TIMES_A_WEEK" nzLabel="2 veces por semana"></nz-option>
          <nz-option [nzValue]="timesEnum.THREE_OR_MORE_TIMES_A_WEEK" nzLabel="3 o más veces por semana"></nz-option>
        </nz-select>
      </div>
      <div nz-col [nzXs]="24" [nzLg]="12" class="mb-sm
        d-flex flex-column justify-content-between">
        <div class="input-label-form">¿En qué cantidad las consume?</div>
        <nz-select formControlName="howOftenEatFastFood" nzPlaceHolder="Seleccione la opción">
          <nz-option [nzValue]="frequencyEnum.MILD" nzLabel="Leve"></nz-option>
          <nz-option [nzValue]="frequencyEnum.MODERATE" nzLabel="Moderado"></nz-option>
          <nz-option [nzValue]="frequencyEnum.HIGH" nzLabel="Abundante"></nz-option>
        </nz-select>
      </div>
    </div>
  </form>
  <div class="d-flex justify-content-end">
    <button nz-button nzType="primary" (click)="onSaveNutritionalForm()" *ngIf="userLogged?.experts">
      <i nz-icon nzType="save" nzTheme="outline"></i>
      Guardar
    </button>
  </div>
  <nz-divider></nz-divider>

  <div>
    <p class="text-info mb-sm">Tiempos de comida</p>
    <nz-table
      nzTableHeaderStyle
      [nzData]="[0]"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      class="fix-column"
      [nzScroll]="{ x: '2100px', y: '500px' }"
      nzSize="small">
      <thead>
        <tr class="header">
          <th nzWidth="300px"></th>
          <th nzWidth="360px" *ngFor="let header of headersFoodTime">{{ header.text }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let question of tableQuestions; index as i">
          <td>
            <p class="input-label-form mb-xs">{{ question.value }}</p>
          </td>
          <td *ngFor="let data of question.data; index as j">
            <ng-container *ngIf="question.type === 'timeMeals'">
              <ng-container *ngTemplateOutlet="tplTimeMeals, context: {data: data, index: j}"></ng-container>
            </ng-container>
            <ng-container *ngIf="question.type === 'cereals'">
              <ng-container *ngTemplateOutlet="tplCereals, context: {data: data, index: j}"></ng-container>
            </ng-container>
            <ng-container *ngIf="question.type === 'beverages'">
              <ng-container *ngTemplateOutlet="tplBeverages, context: {data: data, index: j}"></ng-container>
            </ng-container>
            <ng-container *ngIf="question.type === 'dressings'">
              <ng-container *ngTemplateOutlet="tplDressings, context: {data: data, index: j}"></ng-container>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <ng-template #tplTimeMeals let-data="data">
    <ng-template #tplAdd>
      <p *ngIf="data.info.status !== 'write' && !(isPatient$ | async)" class="text-link cursor-pointer" [class.disable-btn]="!userLogged?.experts" (click)="userLogged?.experts ?
        data.info.status= 'write' : '';">Agregar horario
      </p>
      <p *ngIf="data.info.status !== 'write' && (isPatient$ | async)">No se ha agregado horario</p>
    </ng-template>
    <p class="cursor-pointer" *ngIf="data.info.status === 'read' && data.info.from && data.info.to && data.info.valid; else tplAdd"
      (click)="onChangeWriteHour(data)">
      <img *ngIf="!(isPatient$ | async)" loading="lazy" class="icon-edit mr-xs" src="./../../../assets/images/icons/icons8-lapiz-100.png" alt="">
      <span>De {{data.info.from | date: 'h:mm a'}} a {{ data.info.to | date: 'h:mm a' }}</span>
    </p>
    <div *ngIf="data.info.status === 'write'">
      <div class="d-flex align-items-center">
        <nz-time-picker
          [nzUse12Hours]="true"
          nzFormat="h:mm a"
          nzPlaceHolder="h:mm"
          [(ngModel)]="data.info.from">
        </nz-time-picker>
        <p class="date-to">a</p>
        <nz-time-picker
          [nzUse12Hours]="true"
          nzFormat="h:mm a"
          nzPlaceHolder="h:mm"

          [(ngModel)]="data.info.to">
        </nz-time-picker>
      </div>
      <p nz-typography [nzType]="'danger'" *ngIf="!data.info.valid" @fadeInAnimation class="mb-xxs mt-xxs text-error">{{data.info.errorMessage}}</p>
      <div class="d-flex justify-content-end mt-xs">
        <button nz-button nzType="default" class="btn-default mr-xs" (click)="cancelTdOnTable(data)">Cancelar</button>
        <button nz-button nzType="primary" (click)="changeTime(data.info)">Guardar</button>
      </div>
    </div>
  </ng-template>

  <ng-template #tplCereals let-data="data">
    <ng-template #tplAdd>
      <p *ngIf="data.info.status !== 'write' && !(isPatient$ | async)" class="text-link cursor-pointer" [class.disable-btn]="!userLogged?.experts" (click)="userLogged?.experts ?
        data.info.status= 'write' : '';">Agregar cereal
      </p>
      <p *ngIf="data.info.status !== 'write' && (isPatient$ | async)">No se ha agregado ningún cereal</p>
    </ng-template>
    <p class="cursor-pointer" *ngIf="data.info.status === 'read' && data.info.textValue && data.info.quantity && data.info.unit && data.info.valid; else
      tplAdd"
      (click)="onChangeWriteHour(data)">
      <img *ngIf="!(isPatient$ | async)" loading="lazy" class="icon-edit mr-xs" src="./../../../assets/images/icons/icons8-lapiz-100.png" alt="">
      <span>{{data.info.textValue }}, {{data.info.quantity}} {{data.info.unit}}</span>
    </p>
    <div *ngIf="data.info.status === 'write'">
      <nz-input-group nzCompact class="d-flex align-items-center">
        <nz-select [(ngModel)]="data.info.textValue" nzPlaceHolder="Alimento" style="min-width: 148px;">
          <nz-option [nzLabel]="'Bolillo'" [nzValue]="'bolillo'"></nz-option>
          <nz-option [nzLabel]="'Tortillas'" [nzValue]="'tortillas'"></nz-option>
          <nz-option [nzLabel]="'Galletas saladas'" [nzValue]="'galletas saladas'"></nz-option>
          <nz-option [nzLabel]="'Arroz'" [nzValue]="'arroz'"></nz-option>
          <nz-option [nzLabel]="'Tostadas'" [nzValue]="'tostadas'"></nz-option>
          <nz-option [nzLabel]="'Pan integral'" [nzValue]="'pan integral'"></nz-option>
          <nz-option [nzLabel]="'Pan tostado'" [nzValue]="'pan tostado'"></nz-option>
          <nz-option [nzLabel]="'Pan blanco'" [nzValue]="'pan blanco'"></nz-option>
        </nz-select>
        <nz-input-number [(ngModel)]="data.info.quantity" [nzMin]="1" [nzMax]="3" [nzStep]="1" nzPlaceHolder="1" style="min-width: 47px;max-width:
          47px;"></nz-input-number>
        <nz-select [(ngModel)]="data.info.unit" nzPlaceHolder="Unidad" style="min-width: 148px;">
          <nz-option [nzLabel]="'Pieza(s)'" [nzValue]="'pieza(s)'"></nz-option>
          <nz-option [nzLabel]="'Porcion(es)'" [nzValue]="'Porcion(es)'"></nz-option>
        </nz-select>
      </nz-input-group>
      <p nz-typography [nzType]="'danger'" *ngIf="!data.info.valid" @fadeInAnimation class="mb-xxs mt-xxs text-error">Campos inválidos.</p>
      <div class="d-flex justify-content-end mt-xs">
        <button nz-button nzType="default" class="btn-default mr-xs" (click)="cancelTdOnTable(data)">Cancelar</button>
        <button nz-button nzType="primary" (click)="changeCereals(data.info)">Guardar</button>
      </div>
    </div>
  </ng-template>

  <ng-template #tplBeverages let-data="data">
    <ng-template #tplAdd>
      <p *ngIf="data.info.status !== 'write' && !(isPatient$ | async)" class="text-link cursor-pointer" [class.disable-btn]="!userLogged?.experts" (click)="userLogged?.experts ?
        data.info.status= 'write' : '';">Agregar bebida
      </p>
      <p *ngIf="data.info.status !== 'write' && (isPatient$ | async)">No se ha agregado ninguna bebida</p>
    </ng-template>
    <p class="cursor-pointer" *ngIf="data.info.status === 'read' && data.info.textValue && data.info.quantity && data.info.unit && data.info.valid; else
      tplAdd"
      (click)="onChangeWriteHour(data)">
      <img *ngIf="!(isPatient$ | async)" loading="lazy" class="icon-edit mr-xs" src="./../../../assets/images/icons/icons8-lapiz-100.png" alt="">
      <span>{{ data.info.textValue }}, {{data.info.quantity}} {{data.info.unit}}</span>
    </p>
    <div *ngIf="data.info.status === 'write'">
      <nz-input-group nzCompact class="d-flex align-items-center">
        <nz-select [(ngModel)]="data.info.textValue" nzPlaceHolder="Bebida" style="min-width: 148px;">
          <nz-option [nzLabel]="'Agua natural'" [nzValue]="'agua natural'"></nz-option>
          <nz-option [nzLabel]="'Agua de frutas naturales'" [nzValue]="'agua de frutas naturales'"></nz-option>
          <nz-option [nzLabel]="'Agua de fruta artificial'" [nzValue]="'agua de fruta artificial'"></nz-option>
          <nz-option [nzLabel]="'Jugo comercial'" [nzValue]="'jugo comercial'"></nz-option>
          <nz-option [nzLabel]="'Refresco'" [nzValue]="'refresco'"></nz-option>
          <nz-option [nzLabel]="'Refresco de dieta'" [nzValue]="'refresco de dieta'"></nz-option>
          <nz-option [nzLabel]="'Café sin azúcar'" [nzValue]="'café sin azúcar'"></nz-option>
          <nz-option [nzLabel]="'Café con azúcar'" [nzValue]="'café con azúcar'"></nz-option>
          <nz-option [nzLabel]="'Café con endulcorante'" [nzValue]="'café con endulcorante'"></nz-option>
          <nz-option [nzLabel]="'Té sin azúcar,'" [nzValue]="'té sin azúcar,'"></nz-option>
          <nz-option [nzLabel]="'Té con azúcar,'" [nzValue]="'té con azúcar,'"></nz-option>
        </nz-select>
        <nz-input-number [(ngModel)]="data.info.quantity" [nzMin]="1" [nzMax]="3" [nzStep]="1" nzPlaceHolder="1" style="min-width: 47px;max-width:
          47px;"></nz-input-number>
        <nz-select [(ngModel)]="data.info.unit" nzPlaceHolder="Unidad" style="min-width: 148px;">
          <nz-option [nzLabel]="'Vaso(s)'" [nzValue]="'vaso(s)'"></nz-option>
          <nz-option [nzLabel]="'Taza(s)'" [nzValue]="'taza(es)'"></nz-option>
        </nz-select>
      </nz-input-group>
      <p nz-typography [nzType]="'danger'" *ngIf="!data.info.valid" @fadeInAnimation class="mb-xxs mt-xxs text-error">Campos inválidos.</p>
      <div class="d-flex justify-content-end mt-xs">
        <button nz-button nzType="default" class="btn-default mr-xs" (click)="cancelTdOnTable(data)">Cancelar</button>
        <button nz-button nzType="primary" (click)="changeBeverages(data.info)">Guardar</button>
      </div>
    </div>
  </ng-template>

  <ng-template #tplDressings let-data="data">
    <ng-template #tplAdd>
      <p *ngIf="data.info.status !== 'write' && !(isPatient$ | async)" class="text-link cursor-pointer" [class.disable-btn]="!userLogged?.experts" (click)="userLogged?.experts ?
        data.info.status= 'write' : '';">Agregar aderezo
      </p>
      <p *ngIf="data.info.status !== 'write' && (isPatient$ | async)">No se ha agregado ningún aderezo</p>
    </ng-template>
    <p class="cursor-pointer" *ngIf="data.info.status === 'read' && data.info.textValue && data.info.valid; else tplAdd"
      (click)="onChangeWriteHour(data)">
      <img *ngIf="!(isPatient$ | async)" loading="lazy" class="icon-edit mr-xs" src="./../../../assets/images/icons/icons8-lapiz-100.png" alt="">
      <span>{{ data.info.textValue }}</span>
    </p>
    <div *ngIf="data.info.status === 'write'">
      <nz-select [(ngModel)]="data.info.textValue" nzPlaceHolder="Aderezo" [nzDropdownRender]="renderTemplateMoreOptionDressings">
        <nz-option *ngFor="let dressings of nutritionalDressings" [nzValue]="dressings.value" [nzLabel]="dressings.label"></nz-option>
      </nz-select>

      <ng-template #renderTemplateMoreOptionDressings>
        <nz-divider style="margin: 5px 0;"></nz-divider>
        <div class="container-more-option">
          <input type="text" nz-input #inputElement placeholder="Otra opción" />
          <a class="add-item" (click)="onAddOtherNutritionalDressings(inputElement)">
            <button nz-button nzType="default" class="btn-default"><i nz-icon nzType="plus" nzTheme="outline"></i></button>
          </a>
        </div>
      </ng-template>
      <p nz-typography [nzType]="'danger'" *ngIf="!data.info.valid" @fadeInAnimation class="mb-xxs mt-xxs text-error">Campo inválido.</p>
      <div class="d-flex justify-content-end mt-xs">
        <button nz-button nzType="default" class="btn-default mr-xs" (click)="cancelTdOnTable(data)">Cancelar</button>
        <button nz-button nzType="primary" (click)="changeDressings(data.info)">Guardar</button>
      </div>
    </div>
  </ng-template>

</ng-container>

<!-- modal para agregar alergias -->
<app-modal-add-allergy
  [isVisible]="this.modalAddAllergyVisible"
  [allergies]="this.excludedAllergyIngredients"
  (close)="this.onCloseModalAddAllergy($event)"
></app-modal-add-allergy>

